/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Page_Error_HomeInputs */

const sv_page_error_home = /** @type {(inputs: Page_Error_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Till startsidan`)
};

const en_page_error_home = /** @type {(inputs: Page_Error_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Home`)
};

/**
* | output |
* | --- |
* | "Home" |
*
* @param {Page_Error_HomeInputs} inputs
* @param {{ locale?: "sv" | "en" }} options
* @returns {LocalizedString}
*/
export const page_error_home = /** @type {((inputs?: Page_Error_HomeInputs, options?: { locale?: "sv" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Page_Error_HomeInputs, { locale?: "sv" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "sv") return sv_page_error_home(inputs)
	return en_page_error_home(inputs)
});